module.exports = __webpack_public_path__ + "static/img/Sam-Stonestreet.3a7d447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sam-Stonestreet.jpg
// module id = ALjU
// module chunks = 0